module.exports = "<div class=\"l-wrapper\">\n  <!-- 06-00-00_exportar -->\n  <div class=\"c-editable-box\">\n    <export-users></export-users>\n  </div>\n\n  <div class=\"c-editable-box h-mt20\">\n    <export-services></export-services>\n  </div>\n\n  <div class=\"c-editable-box h-mt20\">\n    <export-cleaners></export-cleaners>\n  </div>\n\n  <!--<div class=\"c-editable-box h-mt20\">\n         <export-bills></export-bills>\n    </div>-->\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/exports/templates/main-exports.html
// module id = ./src/app/modules/exports/templates/main-exports.html
// module chunks = main